import React from 'react'
import Footer from '../../Footer'
import fig1 from '../../../img/hci/texel/fig1.png'
import fig2 from '../../../img/hci/texel/2.png'
import '../Proj.css'
import Tags from '../../Tags'

export default class ProjTexel extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div id='texel-title'>
                    <h1>TexelBlocks: Dynamic Surfaces for Physical Interactions</h1>
                    <p><b>Vivian Hsinyueh Chan</b>, Yu-Chen Chan, Pin-Hsuan Peng, Lung-Pan Cheng</p>
                    <h3>CHI EA'21 accepted</h3>
                </div>
                <div className='proj-fig1'>
                    <img src={fig1} />
                </div>
                <p>We present TexelBlocks, modular blocks that dynamically change their surfaces to support rich physical interactions.
                    The core component of each block is a motorized crawler belt with a set of material patches attached to it, allowing each of the TexelBlocks
                    to change their surface independently and be concatenated into flat surfaces of various sizes. 
                    We implemented a working system that controls 24 TexelBlocks to form a 6x4 dynamic surfaces.
                </p>
                <div className='proj-fig'>
                    <img src={fig2} />
                </div>
                <p>
                With the working prototype, we developed five applications such as context-aware surface adaptation, real-time tactile feedback, immersive storytelling
                with dynamic background, real-time embodied platform game, and a surface-changing board game to demonstrate rich physical interactions of dynamic surfaces.
                </p>
                <p className='little-title'>Video Preview</p>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/KYl8OgbFcIc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <p className='little-title'>Links(Will be ready in the future)</p>
                <div id='texel-tags'>
                    <a href=''>
                        <Tags color='gray' text='ACM Link '/>
                    </a>
                    <a href=''>
                        <Tags color='gray' text='Video Link'/>
                    </a>
                </div>
                <p className='little-title'>I will be presenting this work in the virtual conference on Mon. May 10 10:00-12:00 and 18:00 (UTC+9:00).</p>
                <Footer back={true}/>
            </div>
        )
    }
}